<template>
	<div class="component-index">
		<FunctionTitle :title="mainTitle" />
		<CommonFlame :title="title">
			<template v-if="!$vuetify.breakpoint.xs" v-slot:app-bar-btn>
				<v-btn v-if="authority" color="primary" class="ml-2" @click.stop="redirectTo">
					<v-icon class="mr-1">mdi-plus</v-icon>
					案件作成
				</v-btn>
				<v-menu offset-y :close-on-content-click="false">
					<template v-slot:activator="{ on, attrs }">
						<v-btn color="primary" dark v-bind="attrs" v-on="on"> <v-icon class="mr-2">mdi-magnify</v-icon>検索 </v-btn>
					</template>
					<v-card width="300px">
						<v-app-bar dense color="primary" flat>
							<v-app-bar-title class="color-white text-body-1 font-weight-bold">絞り込み検索</v-app-bar-title>
						</v-app-bar>
						<v-card-text class="pa-2">
							<v-form ref="form">
								<v-menu
									class="mr-1"
									v-model="createdDatePicker"
									:close-on-content-click="false"
									transition="scale-transition"
									offset-y
									min-width="auto"
								>
									<template v-slot:activator="{ on, attrs }">
										<v-text-field
											v-model="createdDatesText"
											label="作成日"
											hint="作成日を選択してください"
											class="mt-4"
											outlined
											dense
											v-bind="attrs"
											v-on="on"
										></v-text-field>
									</template>
									<v-date-picker class="date-picker" v-model="createdDateRange" no-title range locale="ja-JP">
										<v-spacer></v-spacer>
									</v-date-picker>
								</v-menu>

								<v-menu v-model="quotationDatePicker" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field
											v-model="quotationDatesText"
											label="見積納期"
											hint="見積納期を選択してください"
											class="mt-4"
											outlined
											dense
											v-bind="attrs"
											v-on="on"
										></v-text-field>
									</template>
									<v-date-picker class="date-picker" v-model="quotationDateRange" no-title range locale="ja-JP"> </v-date-picker>
								</v-menu>

								<v-text-field :label="'見積番号'" v-model="q.quotation_number_eq" class="mt-4" dense outlined />

								<v-select
									v-model="q.team_id_eq"
									:items="teams"
									item-text="name"
									item-value="id"
									label="チーム"
									no-data-text="チーム情報がありません"
									class="mt-4"
									hint="チームを選択してください"
									clearable
									dense
									outlined
									@blur="setTeamMembers"
								/>

								<v-select
									v-model="q.team_member_id_eq"
									:items="team_members"
									clearable
									item-text="name"
									item-value="team_member_id"
									class="mt-4"
									label="担当者"
									hint="担当者を選択してください"
									no-data-text="チームを選択してください"
									dense
									outlined
								/>

								<v-select
									v-model="q.contract_eq"
									:items="contracts"
									clearable
									item-text="name"
									item-value="value"
									class="mt-4"
									label="受注ステータス"
									hint="受注ステータスを選択してください"
									dense
									outlined
								/>

								<v-row class="mt-4" no-gutters justify="center">
									<v-btn color="secondary" outlined @click.prevent="fetchMatter(1)" class="mr-2">
										<v-icon class="mr-2">mdi-magnify</v-icon>
										検索する</v-btn
									>
									<v-btn color="secondary" outlined @click="resetForm"> クリア</v-btn>
								</v-row>
							</v-form>
						</v-card-text>
					</v-card>
				</v-menu>
			</template>

			<template v-if="$vuetify.breakpoint.xs">
				<v-btn v-if="authority" color="secondary" class="ml-2" @click.stop="redirectTo">
					<v-icon class="mr-1">mdi-plus</v-icon>
					案件作成
				</v-btn>
				<v-divider class="mt-1"></v-divider>
				<v-row no-gutters :class="$vuetify.breakpoint.xs ? 'mt-2' : ''">
					<h3 class="text-h6 font-weight-bold">絞り込み検索</h3>
					<v-spacer />
					<v-switch
						color="primary"
						class="mt-0"
						v-model="showSearchForm"
						:label="showSearchForm ? 'フォームを隠す' : 'フォームを表示'"
						hide-details
					/>
				</v-row>

				<template>
					<v-sheet v-if="showSearchForm" elevation="0">
						<v-form ref="form">
							<v-menu v-model="createdDatePicker" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
										v-model="createdDatesText"
										label="作成日"
										class="mt-2"
										required
										outlined
										dense
										:hide-details="true"
										v-bind="attrs"
										v-on="on"
									></v-text-field>
								</template>
								<v-date-picker class="date-picker" v-model="createdDateRange" no-title range locale="ja-JP">
									<v-spacer></v-spacer>
								</v-date-picker>
							</v-menu>
							<v-menu v-model="quotationDatePicker" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
										v-model="quotationDatesText"
										label="見積納期"
										class="mt-2"
										required
										outlined
										dense
										:hide-details="true"
										v-bind="attrs"
										v-on="on"
									></v-text-field>
								</template>
								<v-date-picker class="date-picker" v-model="quotationDateRange" no-title range locale="ja-JP"> </v-date-picker>
							</v-menu>
							<v-text-field :label="'見積番号'" v-model="q.quotation_number_eq" :hide-details="true" class="mt-2" dense outlined />
							<v-select
								v-model="q.team_id_eq"
								:items="teams"
								item-text="name"
								item-value="id"
								label="チーム"
								no-data-text="チーム情報がありません"
								class="mt-2"
								clearable
								dense
								:hide-details="true"
								outlined
								@blur="setTeamMembers"
							/>

							<v-select
								v-model="q.team_member_id_eq"
								:items="team_members"
								clearable
								:hide-details="true"
								item-text="name"
								item-value="team_member_id"
								class="mt-2"
								label="担当者"
								no-data-text="チームを選択してください"
								dense
								outlined
							/>
							<v-select
								v-model="q.contract_eq"
								:items="contracts"
								clearable
								:hide-details="true"
								item-text="name"
								item-value="value"
								class="mt-2"
								label="受注ステータス"
								dense
								outlined
							/>
						</v-form>

						<v-row no-gutters justify="center" class="my-4">
							<v-btn color="secondary" outlined class="mr-2" @click.prevent="fetchMatter(1)">
								<v-icon class="mr-2">mdi-magnify</v-icon>
								検索する</v-btn
							>
							<v-btn color="secondary" outlined @click.prevent="resetForm"> クリア</v-btn>
						</v-row>
					</v-sheet>
					<v-divider />
				</template>
			</template>

			<div>
				<div class="table-container px-2">
					<v-data-table
						locale="ja-JP"
						:headers="headers"
						:items="matters"
						:mobile-breakpoint="240"
						hide-default-footer
						disable-filtering
						disable-pagination
						disable-sort
						no-data-text="データがありません。"
					>
						<template v-slot:item="{ item }">
							<MatterRecord :matter="item" :matter_keys="matter_keys" :current_company_name="current_company_name" />
						</template>
					</v-data-table>

					<PaginationModule :pagination="pagination" @get-page="getPage($event)"></PaginationModule>
				</div>
			</div>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import moment from "moment/min/moment.min.js"
import Qs from "qs"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import rules from "../../helper/rules"
import PaginationModule from "../../modules/PaginationModule.vue"

import CommonFlame from "../shared/CommonFlame.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"
import MatterRecord from "./components/MatterRecord.vue"

export default {
	components: {
		CommonFlame,
		FunctionTitle,
		PaginationModule,
		MatterRecord,
	},
	data() {
		return {
			mainTitle: "案件",
			title: "案件一覧",
			rules,
			matters: [],
			team_members: [],
			teams: [],
			matter_keys: [],
			q: {
				quotation_number_eq: "",
				team_id_eq: "",
				team_member_id_eq: "",
				created_at_gteq: null,
				created_at_lteq: null,
				quotation_deadline_gteq: null,
				quotation_deadline_lteq: null,
				contract_eq: null,
			},
			createdDateRange: [],
			quotationDatePicker: false,
			quotationDateRange: [],
			createdDatePicker: false,
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			headers: [],
			selectedItem: null,
			showSearchForm: true,
			contracts: [
				{ name: "成約", value: true },
				{ name: "失注", value: false },
				{ name: "未定", value: "nil" },
			],
			authority: false,
			current_company_name: "",
		}
	},
	filters: {
		dateFormatter: function (date) {
			if (!date) return ""
			return moment(date).format("YYYY/MM/DD")
		},
	},
	mounted() {
		this.fetchMatter(1)
		this.setTableHeaders()
	},
	methods: {
		setTeamMembers() {
			this.q.team_member_id_eq = null
			this.team_members = []
			if (!this.q.team_id_eq) return
			const selectedTeam = this.teams.find((team) => team.id == this.q.team_id_eq)
			this.team_members = selectedTeam.user_names
		},
		fetchMatter(page) {
			const headers = authenticate.setHeader()
			const params = { q: this.q, page }
			const paramsSerializer = (params) => Qs.stringify(params, { arrayFormat: "brackets" })
			this.setRangeQuery(this.createdDateRange, "created_at_gteq", "created_at_lteq")
			this.setRangeQuery(this.quotationDateRange, "quotation_deadline_gteq", "quotation_deadline_lteq")

			axios
				.get(`/erp/v1/matters`, { params, paramsSerializer, headers })
				.then((res) => {
					this.matters = res.data.matters
					this.teams = res.data.teams
					this.matter_keys = res.data.matter_keys
					this.pagination = res.data.pagination
					this.authority = res.data.authority
					this.current_company_name = res.data.current_company_name
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		setRangeQuery(range, startDate, endDate) {
			this.q[startDate] = null
			this.q[endDate] = null
			if (range.length) {
				const createdFirstDate = range[0]
				const createdLastDate = range[range.length - 1]
				if (createdFirstDate > createdLastDate) {
					this.q[startDate] = createdLastDate
					this.q[endDate] = createdFirstDate
				} else {
					this.q[startDate] = createdFirstDate
					this.q[endDate] = createdLastDate
				}
			}
		},
		redirectTo() {
			this.$router.push({ name: "matter_new" })
		},
		getPage(page) {
			this.fetchMatter(page)
		},
		setTableHeaders() {
			this.headers = [
				{
					text: "見積番号",
					value: "quotation_number",
					width: "150px",
					filter: this.quotationNumberFilter,
				},
				{ text: "枝番号", value: "quotation_sub_number", width: "50px" },
				{
					text: "案件名",
					value: "name",
					width: "200px",
					filter: this.nameFilter,
				},
				{ text: "作成日付", value: "created_at", width: "100px" },
				{ text: "得意先コード", value: "regular_company_code", width: "130px" },
				{
					text: "得意先名",
					value: "regular_company_name",
					width: "200px",
					filter: this.regularCustomerFilter,
				},
				{
					text: "得意先担当者",
					value: "regular_company_person",
					width: "150px",
				},
				{
					text: "エンドユーザー",
					value: "customer_company_name",
					width: "200px",
					filter: this.customerCompanyFilter,
				},
				{ text: "品目、数量(概要)", value: "matter_products", width: "300px" },
				{
					text: "流れ品",
					value: "regularly_sold",
					width: "100px",
					filter: this.regularlySoldFilter,
				},
				{ text: "見積金額(円)", value: "quotation_amount", width: "150px" },
				{
					text: "進捗状況及び契約までのポイント",
					value: "points",
					width: "250px",
				},
				{
					text: "見積納期：年",
					value: "quotation_deadline_year",
					width: "50px",
					filter: this.quotationDeadlineYearFilter,
				},
				{
					text: "見積納期：月",
					value: "quotation_deadline_month",
					width: "50px",
					filter: this.quotationDeadlineMonthFilter,
				},
				{
					text: "見積納期：日",
					value: "quotation_deadline_day",
					width: "50px",
					filter: this.quotationDeadlineDayFilter,
				},
				{
					text: "商品区分",
					value: "product_category",
					width: "150px",
					filter: this.productCategoryFilter,
				},
				{
					text: "分類区分",
					value: "product_sub_category",
					width: "200px",
					filter: this.productSubCategoryFilter,
				},
				{
					text: "受注確度",
					value: "situation",
					width: "50px",
					filter: this.situationFilter,
				},
				{ text: "競合先", value: "competitor", width: "150px" },
				{
					text: "契約",
					value: "contract",
					width: "50px",
					filter: this.contractFilter,
				},
				{ text: "受注見込日", value: "planned_order_date", width: "150px" },
				{ text: "受/失注 期", value: "company_period", width: "150px" },
				{ text: "受注先", value: "lost_to", width: "150px" },
				{
					text: "原価計算依頼日",
					value: "costing_request_date",
					width: "150px",
				},
				{ text: "原価受領日", value: "cost_receipt_date", width: "150px" },
				{ text: "総原価", value: "total_cost", width: "150px" },
				{ text: "受注金額", value: "ordered_amount", width: "150px" },
				{ text: "利益率(受注)", value: "order_profit_ratio", width: "150px" },
				{ text: "失注金額", value: "lost_amount", width: "150px" },
				{ text: "利益率(失注)", value: "lost_profit_ratio", width: "150px" },
				{ text: "最終更新日", value: "updated_at", width: "150px" },
				{ text: "承認予定", value: "matter.meta_data", width: "150px" },
				{ text: "金型納入予定", value: "matter.meta_data", width: "150px" },
				{ text: "整理№管理台帳", value: "matter.meta_data", width: "150px" },
			]
		},
		resetForm() {
			this.$refs.form.reset()
		},
	},
	computed: {
		createdDatesText: {
			get() {
				return this.createdDateRange.length ? this.createdDateRange.join(" ~ ") : null
			},
			set(newValue) {
				this.createdDateRange = []
			},
		},
		quotationDatesText: {
			get() {
				return this.quotationDateRange.length ? this.quotationDateRange.join(" ~ ") : null
			},
			set(newValue) {
				this.quotationDateRange = []
			},
		},
	},
}
</script>
